export const ERROR_MODEL_CLASS_NAME = 'Error'

export const ERRORS_SOURCE = {
  /**
   * An error from the the api.
   * @type {number}
   */
  API: 1,
  /**
   * An error from the web browser.
   * @type {number}
   */
  WEB_FRONTEND: 2,
  /**
   * An error from the web backend.
   * @type {number}
   */
  WEB_BACKEND: 3
}

export const ERRORS_ENDPOINT = {
  CREATE: '/errors'
}

export const DEFAULT_ERROR = 'An error occurred, please try again later.'
